import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent } from "@mui/material";
import { useCallback } from "react";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { DocumentSubmissionApprovedBottomSheetContent } from "./ApprovedContent";

interface DocumentSubmissionApprovedBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentSubmissionApprovedBottomSheet(
  props: DocumentSubmissionApprovedBottomSheetProps
) {
  const { modalState } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet header={<BottomSheetHeader onClose={handleClose} />} modalState={modalState}>
      <DialogContent sx={{ paddingX: 5 }}>
        <DocumentSubmissionApprovedBottomSheetContent />
      </DialogContent>
    </BottomSheet>
  );
}
